<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Fuels",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Fuels",
            items: [
               {
                  text: "Fuels",
                  active: true,
               },                   
            ],

            fuels: [],    

            fuel: {
               id: null,
               fuel_type_id : "",
               price: "",
            },

            stock: "",

            station: {},
            
            modal_title: "Add Fuel",
            button_title: "Save", 
            edit: false,

            all_fuels: [],
            
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.getFuels();
         this.fetchFuels();
      },

      methods: {

         fetchFuels(page_url = null) {

            this.getToken();
            let url = "fuelstation/fuel_station/fuel_types?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.station = responseData.fuel_station;
                     this.fuels = responseData.fuels.data;
                     
                     this.pagination = responseData.fuels.links;
                     this.from = responseData.fuels.from;
                     this.to = responseData.fuels.to;
                     this.total = responseData.fuels.total;
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('sigofuel_fuelstation')) {
               var sigofuel_fuelstation =  JSON.parse(localStorage.getItem('sigofuel_fuelstation'));
               if(sigofuel_fuelstation.token) {
                  this.token = sigofuel_fuelstation.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         getFuels() {
            let url = "fuelstation/fuel_station/getFuels";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.all_fuels = responseData.fuels;
               })
               .catch((err) => console.log(err));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editFuel(fuel) {            
            this.modal_title = "Update Price";
            this.button_title = "Update";
            this.fuel.id = fuel.id; 
            this.fuel.fuel_type_id = fuel.fuel_type_id; 
            this.fuel.price = fuel.price;  
            this.edit = true;
            this.showModal("fuel-modal");
         },

         addFuel() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "fuelstation/fuel_station/fuel/add_fuel";
               formData.append("fuel_type_id", this.fuel.fuel_type_id); 
               this.active_page_url = null;

            } else {
               url = "fuelstation/fuel_station/fuel/update_price";
               formData.append("fuel_type_id", this.fuel.fuel_type_id); 
            }        

            formData.append("price", this.fuel.price);
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if(response.status == 200) {
                  this.$swal("", response.data.message, "success");        
               }
                  
               this.hideModal('fuel-modal');
               this.fetchFuels(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 400) {
                     this.$swal("", error.response.data.message, "error");
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         editStock(fuel) {            
            
            this.fuel.id = fuel.id; 
            this.fuel.fuel_type_id = fuel.fuel_type_id;
            this.showModal("stock-modal");
         },

         updateStock() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "fuelstation/fuel_station/fuel/update_stock";

            let formData = new FormData();
            formData.append("fuel_type_id", this.fuel.fuel_type_id);
            formData.append("stock", this.stock);

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if(response.status == 200) {
                  this.$swal("", response.data.message, "success");        
               }
                  
               this.hideModal('stock-modal');
               this.fetchFuels(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            // .finally(() => (this.loading = false));
         },

         clearForm() {           
            
            this.modal_title = "Add Fuel";
            this.button_title = "Add";
            this.fuel.fuel_type_id = "";    
            this.fuel.fuel_station_id = ""; 
            this.fuel.price = "";  
            this.stock = "";

            this.errors = {};
            this.edit = false;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                       
                        <b-button v-b-modal.fuel-modal variant="primary" class="float-end">Add Fuel</b-button>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Fuel (English)</th>
                              <th>Fuel (Somali)</th>
                              <th>Price</th>
                              <th>Stock (in litres)</th>
                              <th>Created on</th>
                              <th>Last Updated On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(fuels.length)">
                           <tr v-for="(fuel) in fuels" :key="fuel.id">
                              <td>{{fuel.fuel_en}}</td>
                              <td>{{fuel.fuel_so}}</td>
                              <td>${{fuel.price}}</td>
                              <td>{{fuel.stock}}</td>
                              <td>{{fuel.converted_created_at | formatDateTime}}</td>
                              <td>{{fuel.converted_updated_at | formatDateTime}}</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editFuel(fuel)">Update Price</b-button>

                                 <b-button variant="primary" class="me-2 mb-2 btn-sm" @click="editStock(fuel)">Update Stock</b-button>

                                 <router-link :to="{ name: 'fuels.stocklogs', params: {id: fuel.fuel_type_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Stock Logs</router-link>

                                 <router-link :to="{ name: 'fuels.pricelogs', params: {id: fuel.fuel_type_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Price Logs</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No fuels found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->   

                  <!---- modal starts ---->
                  <b-modal ref="fuel-modal" id="fuel-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addFuel()">                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12" v-if="!edit">
                              <label>Fuel <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="fuel.fuel_type_id" v-bind:class="{ 'is-invalid': Boolean(errors.fuel_type_id) }">
                                 <option value="" v-if="!edit">Select</option>
                                 <option :value="fu.id" v-for="fu in all_fuels" :key="fu.id">{{fu.fuel_en}}</option>
                              </select>

                              <div v-for="(val, index) in errors.fuel_type_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-12">
                              <label>Price <span class="text-danger">*</span></label>
                              <b-form-input v-model="fuel.price" v-bind:class="{ 'is-invalid': Boolean(errors.price) }"></b-form-input>

                              <div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('fuel-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->    


                  <!---- modal starts ---->
                  <b-modal ref="stock-modal" id="stock-modal" title="Update Stock" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="updateStock()">
                        <b-row>                

                           <b-col lg="12" class="form-group">
                              <label class="control-label">Stock <span class="text-danger">*</span></label>
                              <b-form-input type="number" min="1" v-model="stock" v-bind:class="{ 'is-invalid': Boolean(errors.stock) }"></b-form-input>

                              <div v-for="(val, index) in errors.stock" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>   
                           
                           <b-col lg="12">
                              <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                              <b-button class="" variant="light" @click="hideModal('stock-modal')">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->       

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
